module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Chapters"
  }, [_c('span', [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph"
  }, [_vm._v("I "), _c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("called home to Uncle James and Aunt Celia that night before going to bed. It was awkward and difficult.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("My sleep was restless for the rest of the night. I blamed it on the soft mattress at the hotel. I had gotten so used to sleeping in the car or under the stars that a real, honest-to-goodness bed gave me bad dreams. Thinking about murder all day might have had something to do with it as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("In my mind’s eye, I could see Sarai, curled up into a ball at the end of that hideous paisley couch I had back in college. Her feet were tucked underneath her, her arms wrapped around her knees, her teeth absentmindedly digging into her lower lip. I’m reading a story from the book, that cursed, vile tome I threw into the fire years ago. Every word terrifies her, tantalizes her, the fear and the passion all tangled up together inside of her. Sarai loved to be scared.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("In the dark recesses of that ancient cavern,")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("I could hear the mad priest still chanting,")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("His deathless voice repeating the forbidden words,")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("Fast and frantic, an insane jumble of ranting;")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("Yog-Shoggoth Abishai Nostaru Nofar Immi-shoggoth.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("Yog-Shoggoth Abishai Nostaru Nofar Immi-shoggoth.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Then, she is next to me, her face nuzzled up against mine. She kisses me, her lips seeking deep purchase in mine. Her taste is salty, metallic…bloody from where she bit her lip. She pulls back from me with a mischievous grin. “Blood of a virgin. Better be careful.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“You know we could fix that. No mad priest could use you for a sacrifice if you weren’t a virgin.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Mmm. I suppose you’d chant over me as we made love.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Only if you wanted me to.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She pulls back into her story-time position. “Finish the story. If I like the way it ends, maybe you’ll get lucky.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Let’s see, where was I …?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("Yog-Shoggoth Abishai Nostaru Nofar Immi-shoggoth.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("Yog-Shoggoth Abishai Nostaru Nofar Immi-shoggoth.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("Each syllable of that dark tongue echoed")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("Over water and stone and I knew then what must be done.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("When I pause to turn the page, it is no longer Sarai on the couch with me, but Agent Devereaux. “We found my body, you know.” She pulls off her t-shirt to reveal the bloody cavity between her breasts. “Why? Why did you kill me?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Blood of a virgin. How could I have known?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I hear Duchess’ voice whisper in my ear. “You’re clearly not human. You ate her. Every last drop.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I dreamed that same dream with slight variations five times that night. In the worst of them, she made love to me while I stared at the hole where her heart should have been.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36aa4d09","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0017.vue
// module id = 111
// module chunks = 0